import { useContext } from 'react';
import { addTocartBogoHandler } from '../../../Utils/productAction';
import AddItemLoader from '../../CartOverlayContainer/Cart/CartProducts/AddItemLoader';
import { getProductIds } from './common';
import { fireUpdateQuantityEvent } from './instrumentation';
import { AddDeleteItem } from './styled';
import CardContext from '../ProductCard/ProductCardContext';
import { getCartItemsCookie } from '../../../Utils/helper';

export default function PlusMinusButtons(props) {
  const contextData = useContext(CardContext);
  const {
    setAddedToCart,
    productData,
    setOfferCartData,
    offerCartData,
    setChangeCartCount,
    setLoaderState,
    showLoader,
    setShowLoader,
  } = contextData;
  const { setErrorMessage } = props;
  const offerCode = offerCartData?.offerData?.offerCode;
  const productId = productData?.id;
  const quantity = productData?.quantity;

  const addRemoveItemsHandler = async (add, remove) => {
    setChangeCartCount(true);
    fireUpdateQuantityEvent(
      productData,
      add ? '+' : '-',
      add ? quantity + 1 : quantity - 1,
      offerCode,
      productId,
    );
    const cartItemsLength = getCartItemsCookie().split(',').length;
    // close popup when no item is left in cart
    let params = {};
    if (remove && quantity == 1) {
      setLoaderState('');
    }
    if (cartItemsLength == 1 && remove && quantity == 1) {
      params = {
        productId: productId,
        ids: getProductIds(offerCartData?.productList),
        add: false,
        less: true,
        addToCart: false,
        // selectedProductId: selectedCard,
      };
    } else {
      if (quantity === 5 && add) {
        setErrorMessage('Item quanity is limited to 5 per order');
        return;
      }
      params = {
        productId: productId,
        ids: getProductIds(offerCartData?.productList),
        add: add,
        less: remove,
        addToCart: false,
        // selectedProductId: selectedCard,
      };
    }
    if (setAddedToCart) {
      setAddedToCart(true);
    }
    setShowLoader(add ? '+' : '-');
    const data = await addTocartBogoHandler(params);
    setOfferCartData(data?.data);

    setTimeout(() => {
      setShowLoader('');
    }, 600);
  };
  return (
    <AddDeleteItem>
      <div
        onClick={() => addRemoveItemsHandler(false, true)}
        className="delete_items common_button"
      >
        {showLoader === '-' ? (
          <AddItemLoader />
        ) : (
          <img
            src={
              quantity > 1
                ? '/images/minusblack.svg'
                : '/images/deleteblack.svg'
            }
            alt=""
            className="plusMinusImage"
          />
        )}
      </div>
      <div className="total_items common_button">{quantity}</div>
      <div
        onClick={() => addRemoveItemsHandler(true, false)}
        className={`plus_items common_button ${quantity > 4 ? 'disabled' : ''}`}
      >
        {showLoader === '+' ? (
          <AddItemLoader />
        ) : (
          <img src="/images/plusblack.svg" alt="" className="plusMinusImage" />
        )}
      </div>
    </AddDeleteItem>
  );
}
